import React, { useEffect, useState } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useSelector } from "react-redux";
import { recaptchaSiteKey as defaultKey } from "../config/ClientIds";

const RecaptchaWrapper = ({ children }) => {
    const settingsdata = useSelector((state) => state.settingsdata);
    const settings = settingsdata.settings;
    const keyFromSettings = settings?.google?.recaptcha?.siteKey;
    const [siteKey, setSiteKey] = useState(null);

    useEffect(() => {
        const activeKey = keyFromSettings || defaultKey;
        if (activeKey && activeKey !== siteKey) {
            setSiteKey(activeKey);
        }
    }, [keyFromSettings, siteKey]);

    if (settingsdata.loading || !siteKey) {
        return <>{children}</>;
    }

    // [FIX] Strict Enterprise check. 
    // We no longer auto-detect by 6Lep prefix because v3 keys can also start with 6Lep.
    // Also handling potential french spelling "entreprise" from settings.
    const mode = settings?.google?.recaptcha?.mode;
    const isEnterprise = (mode === "enterprise" || mode === "entreprise");
    //console.log("[RECAPTCHA_WRAPPER] siteKey:", siteKey, "mode:", mode, "isEnterprise:", isEnterprise);

    // [FIX] Force Standard mode for Standard v3 keys to avoid 401 on /pat (Private Access Tokens)
    // Even if settings say enterprise, a 6Lep key (standard) will fail on enterprise features.
    const isEnterpriseValue = isEnterprise && !siteKey.startsWith('6Lep');

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={siteKey}
            key={`${siteKey}-${isEnterpriseValue}`}
            useEnterprise={isEnterpriseValue}
            useRecaptchaNet={false} // Use official google.com/recaptcha domain
            scriptProps={{
                async: true,
                defer: true,
                appendTo: "head"
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
};

export default RecaptchaWrapper;
